export var OrderElementTypeEnum;
(function (OrderElementTypeEnum) {
    OrderElementTypeEnum["ELEMENT"] = "storeItem";
    OrderElementTypeEnum["BUNDLE_ITEM"] = "storeItemBundle";
    OrderElementTypeEnum["PROPERTY"] = "itemOptions";
    OrderElementTypeEnum["SELECTION_GROUP"] = "itemBaseGroup";
    OrderElementTypeEnum["SELECTION"] = "itemBase";
    OrderElementTypeEnum["COMBO"] = "itemCombo";
})(OrderElementTypeEnum || (OrderElementTypeEnum = {}));
//# sourceMappingURL=OrderElementTypeEnum.js.map